import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./style.scss";
import { Translate } from "../../../Enums/Tranlate";
import AdminService from "../../../../services/AdminManagment/AdminService";
import { useNavigate } from "react-router-dom";

const EmployeeDashboard = () => {
	const [formData, setFormData] = useState({
		totalCompany: "0",
		totalPeople: "0",
		totalLeave: "0",
		totalAssets: "0",
		totalAdmins: "0",
		totalResignation: "0",
	});
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const navigate = useNavigate();

	useEffect(() => {
		setLoading(true);
		new AdminService()
			.getDashboard()
			.then((res) => {
				if (res?.status) {
					setFormData(res.data.data);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	if (loading) {
		return (
			<Row>
				{Object.entries(formData)?.map((data) => {
					return (
						<Col className="col-md-4 col-sm-6">
							<Card style={{ height: "128.75px" }}>
								<Card.Body>
									<div class="skeleton-loader">
										<div class="loader-header"></div>
										<div class="loader-content"></div>
									</div>
								</Card.Body>
							</Card>
						</Col>
					);
				})}
			</Row>
		);
	}

	return <div></div>;
};

export default EmployeeDashboard;
